import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo-svg.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-9c88e06a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "login-container mx-auto mt-8 text-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: 500
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Login to RTIO Asset Management", -1))
const _hoisted_4 = {
  key: 1,
  class: "login-container mx-auto mt-8 text-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Reset Password", -1))

import { ref } from "vue";
import { useAuthStore } from "@/store/auth";
import router from "@/router";
import { useNotifierStore } from "@/store/notifier";


export default /*#__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props) {

const notifier = useNotifierStore();
const auth = useAuthStore();

const email = ref("");
const password = ref("");

const reset = ref(false);

const resetPassword = async () => {
  try {
    await auth.resetPassword(email.value);
    reset.value = false;
    notifier.success("Password reset email sent");
  } catch (error) {
    notifier.error("Invalid email");
    console.error(error);
  }
};

const login = async () => {
  try {
    await auth.login(email.value, password.value);
    router.push("/asset-management-plans");
  } catch (error) {
    notifier.error("Invalid email or password");
    console.error(error);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (!reset.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createVNode(_component_v_text_field, {
          class: "mt-2",
          modelValue: email.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
          label: "Email",
          variant: "outlined",
          density: "compact",
          "hide-details": "",
          onKeydown: _withKeys(login, ["enter"])
        }, null, 8, ["modelValue"]),
        _createVNode(_component_v_text_field, {
          class: "mt-2",
          modelValue: password.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
          label: "Password",
          type: "password",
          variant: "outlined",
          density: "compact",
          "hide-details": "",
          onKeydown: _withKeys(login, ["enter"])
        }, null, 8, ["modelValue"]),
        _createVNode(_component_v_btn, {
          "aria-label": "Login",
          class: "mt-4",
          color: "primary",
          flat: "",
          block: "",
          onClick: login
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Login ")
          ]),
          _: 1
        }),
        _createVNode(_component_v_btn, {
          "aria-label": "Reset Password",
          class: "mt-4",
          color: "primary",
          flat: "",
          block: "",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (reset.value = true))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Reset Password ")
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_v_text_field, {
          modelValue: email.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((email).value = $event)),
          label: "Email",
          variant: "outlined",
          density: "compact",
          "hide-details": ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_v_btn, {
          "aria-label": "Reset Password",
          class: "mt-4",
          color: "primary",
          flat: "",
          block: "",
          onClick: resetPassword
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Reset ")
          ]),
          _: 1
        })
      ]))
}
}

})